module.exports = __webpack_public_path__ + "img/plan-2-b4.ce368731.png";